module.exports = __webpack_public_path__ + "media/application/images/svgs/cloud-lightning-2818964d2426153b5b0e2ba9433bbc50.svg";